<template>
	<div class="export">
		<xunjia ref="xunjia" v-if="type == '集运询价'" :item="item" :l_id="l_id"></xunjia>
		<baojia ref="baojia" v-if="type == '集运报价'" :item="item" :l_id="l_id"></baojia>
		<createtransport ref="createtransport" v-if="type == '集运订单'" :item="item" :l_id="l_id"></createtransport>
		<baojiaxs ref="baojiaxs" v-if="type == '集运销售报价'" :item="item" :l_id="l_id"></baojiaxs>
		<transportfee ref="transportfee" v-if="type == '集运费用'" :item="item" :l_id="l_id"></transportfee>
	</div>
</template>
<script>
import xunjia from '@/components/transport/xunjia.vue';
import baojia from '@/components/transport/baojia.vue';
import baojiaxs from '@/components/transport/baojia_xs.vue';
import createtransport from '@/components/transport/createtransport.vue';
import transportfee from '@/components/transport/transportfee.vue';
export default {
	components: {
		xunjia,
		baojia,
		createtransport,
		baojiaxs,
		transportfee
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			pageparam: {},
			curpkval: '',
			iscopy: 0,
			type: '',
			orderinfo:{},
			l_id:'',
			isedit:'',
			isdetail:false
		};
	},
	created() {
		
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		//debugger
		if (this.urlparam != undefined) {
			this.type=this.item.l_tablename;
			this.pageparam = this.urlparam;
			if (this.urlparam.pkval != undefined) {
				this.curpkval = this.urlparam.pkval;
				if (this.urlparam.iscopy != undefined) {
					this.iscopy = this.urlparam.iscopy;
				}
			}
			if(this.urlparam.isedit!=undefined)
				this.isedit=this.urlparam.isedit;
			if(this.urlparam.isdetail!=undefined)
				this.isdetail=this.urlparam.isdetail;	
				
			if (this.type == '集运询价') {
				this.$nextTick(function(){
					this.$refs.xunjia.init({pkval:this.curpkval,iscopy:this.iscopy,isdetail:this.isdetail});
				});
			}
			if (this.type == '集运报价') {
				this.$nextTick(function(){
					debugger
					this.$refs.baojia.init({pkval:this.curpkval,iscopy:this.iscopy,isedit:this.isedit,isdetail:this.isdetail});
				});
			}
			if (this.type == '集运销售报价') {
				this.$nextTick(function(){
					debugger
					this.$refs.baojiaxs.init({pkval:this.curpkval,iscopy:this.iscopy,isdetail:this.isdetail});
				});
			}
			if (this.type == '集运订单') {
				this.$nextTick(function(){
					this.$refs.createtransport.init({pkval:this.curpkval,iscopy:this.iscopy,isdetail:this.isdetail});
				});
			}
			if (this.type == '集运费用') {
				this.$nextTick(function(){
					this.$refs.transportfee.init({pkval:this.curpkval,iscopy:this.iscopy,isdetail:this.isdetail});
				});
			}
		}
	},
	methods:{
		
	}
};
</script>
